import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import formatMoney from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { CURRENCIES } from 'constants/app-config'
import { Grid, Icon, Tooltip } from 'gu-ui-kit'

export const AdTax = ({ transfer = null }) => {
  if (!transfer) {
    return null
  }

  const { ad_tax = {} } = transfer
  const { t } = useTranslation(['billing'])
  const { value = 0, currency } = ad_tax ?? {}

  if (value === 0) {
    return null
  }

  return (
    <Grid
      gap={4}
      justifyContent={'end'}
      alignItems={'center'}
      className={styles['billing__ad_tax']}
    >
      <div>{t('ad_tax.label')}</div>
      <div
        className={styles['billing__ad_tax-money']}
        dangerouslySetInnerHTML={{
          __html: formatMoney(value, currency),
        }}
      />

      <Tooltip title={t('ad_tax.tooltip')} placement="top" arrow>
        <Icon name={'information'} color={'Label-Secondary'} size={'s'} />
      </Tooltip>
    </Grid>
  )
}

AdTax.propTypes = {
  transfer: PropTypes.shape({
    value: PropTypes.number,
    currency: PropTypes.oneOf(CURRENCIES),
  }),
}
